
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  name: "StatueHistoryComponent",

  data() {
    return {
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },

  computed: {
    addresses() {
      return store.state.admin.landing.footerAddresses;
    },
  },

  methods: {
    // banner(image: string) {
    //     if (image !== "") {
    //         return this.url + image;
    //     } else {
    //         return "";
    //     }
    // },

    deleteFooterAddress(id: string): void {
      store.dispatch("admin/deleteFooterAddress", id);
    },
  },

  created() {
    store.dispatch("admin/getFooterAddresses");
  },
});
